// 优惠活动
export const discountActs = `/api/unoauth/discountActivity/getDiscountActivityListPage`;
export const discountActDetail = `/api/unoauth/discountActivity/getDiscountActivityDetailed`;
export const useReceiveCoupon = `/api/oauth/userCoupons/insertDiscountActivityUserCoupons`;
export const queryUserCoupons = `/api/oauth/userCoupons/getActivityUserCouponsListByUserId`;
